import * as React from 'react';
import clsx from 'clsx';

import { SUGGEST_DESKTOP_LISTBOX_HEIGHT } from '../../constants';

import styles from './styles.module.css';

export interface ISuggestEmptyListContentProps {
  children: React.ReactNode;
  /** В десктопном попапе — те же фон, рамка, тень и высота, что у списка подсказок. */
  variant?: 'plain' | 'desktop';
  listHeight?: number;
}

export const SuggestEmptyListContent: React.FC<ISuggestEmptyListContentProps> = ({
  children,
  variant = 'plain',
  listHeight = SUGGEST_DESKTOP_LISTBOX_HEIGHT,
}) => {
  const isDesktop = variant === 'desktop';

  return (
    <div
      className={clsx(isDesktop ? styles['desktop'] : styles['plain'])}
      style={isDesktop ? { height: listHeight, maxHeight: listHeight } : undefined}
      data-testid="suggest-empty-content"
    >
      {children}
    </div>
  );
};

SuggestEmptyListContent.displayName = 'SuggestEmptyListContent';
